module.exports = __webpack_public_path__ + "static/media/海鮮炒烏冬.1eb9e0eb.jpg";